import {ValueAndLabelModel} from '../../../../common/model/valueAndLabel.model';
import {UserSummary} from '../../../../account/modules/user/api/entity/userSummary.model';


export class AccountingAccountModel {
    id: number;
    name: string;
    type: ValueAndLabelModel;
    amount: number;
    detailLine1: string;
    detailLine2: string;
    detailLine3: string;
    detailLine4: string;
    user: UserSummary;
}

export class EditBankAccount {
    name: string;
    typeValue: string;
    amount: number;
    detailLine1: string;
    userId: number;
}

